import React from 'react'
import {useSelector} from 'react-redux'
import {getOfferAccessFlowSettings} from 'modules/sapiSearch/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {getIsPrivateDeal} from '@vio/core/src/auth/modules/selectors'
import {OfferPrimaryLayoutVariant} from '@vio/core/src/offer/types/OfferLayout'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

import {OfferCTA} from '../../Shared/OfferCTA'
interface Props {
  offer?: SearchOffer
  isSplitBooking?: boolean
  ctaLoading?: boolean
  hotelId: string
  variant: OfferPrimaryLayoutVariant
  hasWeb2AppPromo?: boolean
}

export const CtaComponent = ({
  offer,
  isSplitBooking,
  ctaLoading = false,
  hotelId,
  variant = 'PrimaryDefault',
  hasWeb2AppPromo = false
}: Props) => {
  const isPrivate = useSelector(getIsPrivateDeal(offer))
  const {monetisation} = useBrandCapabilities()

  const {isSpecialUnlocked, isAppLocked} = useSelector(state =>
    getOfferAccessFlowSettings(state, hotelId, offer?.id)
  )

  const showLockIcon =
    monetisation.offersLockedByDefault && isPrivate && !isSpecialUnlocked
  return (
    <Box
      data-id="OfferCta"
      whiteSpace="nowrap"
      minWidth="128px"
      marginTop={variant !== 'PrimaryDefault' ? 's300' : undefined}
      desktopXs={{marginTop: variant !== 'PrimaryDefault' ? 's400' : undefined}}
    >
      <OfferCTA
        fullWidth
        isSplitBooking={isSplitBooking}
        withSecondaryVariant={hasWeb2AppPromo && variant === 'PrimaryDefault'}
        showLockIcon={showLockIcon}
        isAppLocked={isAppLocked}
        offer={offer}
        hotelId={hotelId}
        loading={ctaLoading}
      />
    </Box>
  )
}
